export const VALUE_TYPE_BY_BLOCK_TYPE = {
	INPUT_BLOCK: 'text',
	FILE_BLOCK: 'file',
	BOOL_BLOCK: 'bool',
	CHECKBOX_BLOCK: 'checkbox'
} as const

export type ApiBlockType = keyof typeof VALUE_TYPE_BY_BLOCK_TYPE
export type ValueType = (typeof VALUE_TYPE_BY_BLOCK_TYPE)[ApiBlockType]

export const BLOCK_TYPE_BY_VALUE_TYPE = Object.fromEntries(
	Object.entries(VALUE_TYPE_BY_BLOCK_TYPE).map(([apiType, valueType]) => [
		valueType,
		apiType
	])
) as Record<ValueType, ApiBlockType>
